import React from 'react';
import ReactDOM from 'react-dom/client';  // Import from react-dom/client
import TApp from './TApp';  // Your root component

const root = ReactDOM.createRoot(document.getElementById('root'));  // Create the root using createRoot
root.render(  // Use render from the root
  <React.StrictMode>
    <TApp />
  </React.StrictMode>
);




/*
import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import TApp from './TApp';


import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
       <TApp />
  </React.StrictMode>,
  document.getElementById('root')  
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
*/
